fetch("https://api.green.gohunt.com/uapi/shopify/user/refresh?destination=https://shop.gohunt.com", {
  method: "GET",
  credentials: "include",
})
  .then((response) => response.json())
  .then((data) => {
    if (data.success == true) {
      Shopify.login = function () {
        location.href = data.result;
      };
    }
  })
  .catch((error) => console.error("Error:", error));
